import styled from 'styled-components'

import ButtonIcon from 'hsds/components/button-icon'

export const ButtonCloseUI = styled(ButtonIcon)`
  &.is-seamless {
    && {
      opacity: 0.5;
      transition: opacity 0.1s ease;
      --hsds-button-main-color: currentColor;
      --hsds-button-background-color: transparent;
      --hsds-button-hover-background-color: transparent;
      --hsds-button-border-color: transparent;
      --hsds-button-hover-border-color: transparent;
      --hsds-button-color: currentColor;
      --hsds-button-hover-color: currentColor;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`
